module.exports = __webpack_public_path__ + "img/tips.2646061d.png";